import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {Translate} from 'app/services/translate';
import {Observable} from 'rxjs';
import {Place} from 'app/model/place';
import {MarkerBubble, PointName, PointDescription, PointGroupHeading, PointList} from './helpers/bubbleLayout';

export class Marker extends Component {
    static get propTypes() {
        return {
            children: PropTypes.number,
            point: PropTypes.instanceOf(Place).isRequired,
            onClick$: PropTypes.instanceOf(Observable).isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.handleMarkerClick = this.handleMarkerClick.bind(this);
    }


    handleMarkerClick() {
        this.props.onClick$.next(this.props.point);
    }

    render() {
        const {name, address, zipCode, city, paymentMethodsArray, openingHoursArray, visible} = this.props.point;

        return (
            <div className="marker-container" onClick={this.handleMarkerClick}>
                {this.props.children}
                <MarkerBubble visibility={{display: visible ? 'block' : 'none'}}>
                    <PointName>{name}</PointName>

                    <PointDescription>
                        {address} <br/>
                        {zipCode}, {city}
                    </PointDescription>

                    {paymentMethodsArray &&
                    <Fragment>
                        <PointGroupHeading>{Translate('commons_agents_map_payment_methods')}</PointGroupHeading>
                        <PointList>
                            {paymentMethodsArray.map((paymentMethod, k) => <li key={k}>{paymentMethod}</li>)}
                        </PointList>
                    </Fragment>
                    }

                    {openingHoursArray &&
                    <Fragment>
                        <PointGroupHeading>{Translate('commons_agents_map_opening_hours')}</PointGroupHeading>
                        <PointList>
                            {openingHoursArray.map((openingHours, k) => <li key={k}>{openingHours}</li>)}
                        </PointList>
                    </Fragment>
                    }
                </MarkerBubble>
            </div>
        );
    }
}
